__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@sbx/sbx-workqueue-management-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@sbx/sbx-deimos-reactui-common", "6.0.3", () => (__webpack_require__.e(870).then(() => (() => (__webpack_require__(98489))))));
			register("@sbx/sbx-ui-components", "9.9.2", () => (__webpack_require__.e(4554).then(() => (() => (__webpack_require__(64554))))));
			register("axios", "1.7.5", () => (__webpack_require__.e(5706).then(() => (() => (__webpack_require__(65706))))));
			register("classnames", "2.5.1", () => (__webpack_require__.e(7073).then(() => (() => (__webpack_require__(87073))))));
			register("indexof", "0.0.3", () => (__webpack_require__.e(9875).then(() => (() => (__webpack_require__(89875))))));
			register("lodash", "4.17.21", () => (__webpack_require__.e(6820).then(() => (() => (__webpack_require__(66820))))));
			register("moment-timezone", "0.5.45", () => (__webpack_require__.e(1155).then(() => (() => (__webpack_require__(3536))))));
			register("moment", "2.30.1", () => (__webpack_require__.e(2198).then(() => (() => (__webpack_require__(52198))))));
			register("multiselect-react-dropdown", "2.0.25", () => (__webpack_require__.e(7455).then(() => (() => (__webpack_require__(99836))))));
			register("prop-types", "15.8.1", () => (__webpack_require__.e(8713).then(() => (() => (__webpack_require__(38713))))));
			register("react-colorful", "5.6.1", () => (__webpack_require__.e(5231).then(() => (() => (__webpack_require__(7612))))));
			register("react-cookie", "4.1.1", () => (__webpack_require__.e(4653).then(() => (() => (__webpack_require__(14653))))));
			register("react-datepicker", "4.25.0", () => (__webpack_require__.e(1748).then(() => (() => (__webpack_require__(99367))))));
			register("react-dom", "18.3.1", () => (__webpack_require__.e(9834).then(() => (() => (__webpack_require__(19834))))));
			register("react-redux", "7.2.9", () => (__webpack_require__.e(6244).then(() => (() => (__webpack_require__(6244))))));
			register("react-redux", "8.1.3", () => (__webpack_require__.e(1559).then(() => (() => (__webpack_require__(71559))))));
			register("react-router-dom", "5.3.4", () => (__webpack_require__.e(5941).then(() => (() => (__webpack_require__(95941))))));
			register("react-router-dom", "6.26.1", () => (__webpack_require__.e(8863).then(() => (() => (__webpack_require__(58863))))));
			register("react-tooltip", "5.28.0", () => (__webpack_require__.e(3663).then(() => (() => (__webpack_require__(73663))))));
			register("react", "18.3.1", () => (__webpack_require__.e(9471).then(() => (() => (__webpack_require__(39471))))));
			register("redux-saga", "1.3.0", () => (__webpack_require__.e(3930).then(() => (() => (__webpack_require__(53930))))));
			register("redux-thunk", "2.4.2", () => (__webpack_require__.e(6376).then(() => (() => (__webpack_require__(66376))))));
			register("redux", "4.2.1", () => (__webpack_require__.e(2574).then(() => (() => (__webpack_require__(40193))))));
			register("rrule", "2.8.1", () => (__webpack_require__.e(701).then(() => (() => (__webpack_require__(73082))))));
			register("styled-components", "5.3.11", () => (__webpack_require__.e(7248).then(() => (() => (__webpack_require__(7248))))));
			register("styled-components", "5.3.3", () => (__webpack_require__.e(3665).then(() => (() => (__webpack_require__(3665))))));
			register("uuid", "9.0.1", () => (__webpack_require__.e(529).then(() => (() => (__webpack_require__(50529))))));
			initExternal(59877);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};